import { useState, useEffect } from 'react';
import api from '../services/api';

/**
 * Returns whether a feature flag is present in the company's active subscription plan.
 * @param {string} feature - e.g. 'whatsapp_flows'
 * @returns {{ hasAccess: boolean|null, plan: object|null, loading: boolean }}
 *   hasAccess is null while loading.
 */
export function useFeatureAccess(feature) {
  const [state, setState] = useState({ hasAccess: null, plan: null, loading: true });

  useEffect(() => {
    let cancelled = false;
    api.get('/subscriptions/current')
      .then(({ data }) => {
        if (cancelled) return;
        const plan = data.subscription?.plan ?? null;
        const features = plan?.features ?? [];
        setState({ hasAccess: features.includes(feature), plan, loading: false });
      })
      .catch(() => {
        if (!cancelled) setState({ hasAccess: false, plan: null, loading: false });
      });
    return () => { cancelled = true; };
  }, [feature]);

  return state;
}
